import { IPublicClientApplication } from '@azure/msal-browser';
import { toast } from 'react-toastify';
import { loginRequest } from '../../utils/AuthConfig.ts';
import { setRedirect } from '../../utils/Util.tsx';

export const callLogin = (
  e: any,
  instance: IPublicClientApplication
) => {
  if (e) e.preventDefault();
  instance.loginRedirect(loginRequest).catch(() => {});
  localStorage.setItem("redirect", 'true');
  setRedirect(true)
};
export const addListener = (
  instance: IPublicClientApplication,
  onSuccessfulLogin: (payload: any) => void
) => {
  instance.addEventCallback((event: any) => {
    if (
      event.eventType === 'msal:acquireTokenSuccess' ||
      event.eventType === 'msal:loginSuccess'
    ) {
      if (event?.payload?.account) {
        onSuccessfulLogin(event.payload);
      } else {
        callLogin(null, instance);
      }
    }
  });
};

export const logoutWithTimer = (instance: IPublicClientApplication) => {
  setTimeout(() => {
    instance.logoutRedirect();
  }, 2000);
};
export const errorWithTimer = (message: string) => {
  setTimeout(() => {
    toast.error(message);
  }, 500);
};
 
export const getLoginParam = (payload: any) =>{
  const isNoc = localStorage.getItem('noc');
  const params= {
    employeeName: payload.account.name,
    email: payload.account.username,
    accessToken: payload.accessToken,
    accessExpiryTime: payload.expiresOn,
    resetToken: payload.idToken,
    resetExpiryTime: payload.extExpiresOn,
    noc: isNoc === 'true'
  };
  return params;
}
